import { showBlocker, hideBlocker } from '../../actions/blocker';
import { fetchFlightDocuments, download } from '../../actions/flight-list';
import MimeIcon from '../mime-icon/mime-icon';
import { connect } from 'react-redux';
import React, { Component } from 'react';

class EffTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
        };
    }

    componentWillMount() {
        this.props.showBlocker();
        this.props.fetchFlightDocuments(this.props.id, { classification: 'EFF' })
            .done((data, textStatus, jqXHR) => this.setState({ data }))
            .fail((jqXHR, status, error) => null)
            .always(this.props.hideBlocker);
    }

    render() {
        const rows = this.state.data.map(({ id, mime, name, size, created, creator }) => <tr key={id}>
            <td className='align-middle text-center text-nowrap'><MimeIcon mime={mime} /></td>
            <td className='align-middle text-left'>
                <button className='btn btn-link text-light'
                    onClick={e => this.props.download(id)}>{name}</button>
            </td>
            <td className='align-middle text-right text-nowrap'>{size}</td>
            <td className='align-middle text-center'>{created}</td>
            <td className='align-middle text-right'>{creator}</td>
        </tr>);

        return <table className='table table-sm text-light m-0 table-fixed'>
            <thead>
                <tr>
                    <th scope='col' className='text-center' style={{ width: '2.5rem' }}></th>
                    <th scope='col' className='text-left' style={{ width: '40%' }}>Name</th>
                    <th scope='col' className='text-right' style={{ width: '8rem' }}>Size (KB)</th>
                    <th scope='col' className='text-center'>Created (yyyy-mm-dd)</th>
                    <th scope='col' className='text-right'>Created by</th>
                </tr>
            </thead>
            <tbody className='bg-dark'>
                {
                    rows.length ? rows :
                        <tr>
                            <td className='text-center font-weight-light font-italic h6'
                                colSpan='100%'>No documents found.</td>
                        </tr>
                }
            </tbody>
        </table>;
    }
}

const mapStateToProps = state => ({});

const mapActionsToprops = {
    showBlocker, hideBlocker,
    fetchFlightDocuments, download,
};


export default connect(mapStateToProps, mapActionsToprops)(EffTable);